import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import { router } from "./router";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./css/comm.less";
import "./css/comm.scss";
// 主题体系（日/夜切换：CSS 变量 + element-ui 全局皮肤）；放在 comm 之后以便覆盖
import "./css/theme.scss";
import "./css/element-theme.scss";
import { initTheme } from "./utils/theme";
import store from "./store";
import Cookies from "js-cookie";
import vuescroll from "vuescroll";
import "vuescroll/dist/vuescroll.css";
import directives from "./directives";
import customTable from "@/components/customTable.vue";
import customModal from "@/components/customModal.vue";

Vue.use(vuescroll);
Vue.use(directives);
import VueJsonp from "vue-jsonp";
Vue.use(VueJsonp);
Vue.component("customTable", customTable);
Vue.component("customModal", customModal);

//全局变量的引入
import globalVariable from "@/api/global_variable.js";
Vue.prototype.GLOBAL = globalVariable;
//富文本编辑器的导入
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
Vue.use(VueQuillEditor);
import "./assets/font/iconfont.css";
//百度地图
import BaiduMap from "vue-baidu-map";
Vue.use(BaiduMap, {
  /* 申请的百度密钥，可以在百度地图官网申请 */
  ak: "X7UHQqYy3WobTXHk3Mw3oN96ahHcQuuG"
});
import i18n from "./lang"; // Internationalization
Vue.use(Element, {
  size: Cookies.get("size") || "mini", // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
});

// 精度计算
import { $calc } from "./utils/precise";
Vue.prototype.$calc = $calc;

//接口导入
import api from "./api/index.js";
Vue.use(api);

initTheme(); // 应用已记忆主题（默认深色），放在 new Vue 之前

new Vue({
  router,
  el: "#app",
  store,
  i18n,
  render: h => h(App)
});
